import React, { memo } from 'react';
import FormFieldLoadingState from '../FormField/FormFieldLoadingState';

const FormFieldTextInputLoadingState: React.FC = () => {
  return (
    <FormFieldLoadingState>
      <div className="w-full h-14 rounded-2xl bg-loading/background-2" />
    </FormFieldLoadingState>
  );
};

export default memo(FormFieldTextInputLoadingState);
